import { render } from "./Button.vue?vue&type=template&id=665afaea"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=665afaea&lang=css"
script.render = render

export default script